import { StatusCard as StatusCardConfigType } from '@/__configs/config_types';
import { ConfigContext } from '@/contextAPI/configContext';
import { useContext } from 'react';
import { PreBuiltGraphs } from '../../DefaultGraphs';
import { CHART_STATUS_LABELS as DEFAULT_CHART_STATUS_LABELS } from '../../chartUtils';
// import { getTotal } from '../DashboardUtils';
import DashboardWidget, { WidgetData } from '../DashboardWidget';
import { generateColorArrayFromConfigs } from '../Reusable/chartUtils';
import { selectGraphsReadOnly, selectStatusTotal } from '@/redux/selectors/dashboardSelectors';
import { useAppSelector } from '@/redux/hooks';

const OpenJobStatus = ({ title, caption }: WidgetData) => {
  const dashboardConfig = useContext(ConfigContext)?.dashboardConfig;
  const statusLabels: StatusCardConfigType[] = dashboardConfig?.statusCards || DEFAULT_CHART_STATUS_LABELS;
  const categories = statusLabels.filter((label) => !label.ignoreOnPieChart);
  const labels = categories.map((category) => category.name);
  const data = categories.map((category) => useAppSelector((state) => selectStatusTotal(state, category.status)));
  const graphsReadOnly = useAppSelector(selectGraphsReadOnly);

  const colors = generateColorArrayFromConfigs(
    data.length,
    dashboardConfig.chartColors,
    dashboardConfig.graphSettings['open-job-status'] ? dashboardConfig.graphSettings['open-job-status'].colors : []
  );

  const replaceColorWithReduxStatusColor = (colorArray: string[], categoryLabels: string[]) => {
    return colorArray.map((color, index) => {
      const category = categoryLabels[index];
      const foundStatus = graphsReadOnly.statusCards.find((statusCard) => statusCard.status === category);
      return foundStatus ? foundStatus.color : color;
    });
  };

  // TODO: CONNECTED LEGEND TO DATA,  NOW NEED TO PASS IT INTO THINGS CORRECTLY AND RENDER THE COMPLETE LEGEND AT WILL
  return (
    <DashboardWidget
      {...{ title }}
      {...{ caption }}
      data={{
        id: PreBuiltGraphs.OPEN_JOB_STATUS,
        labels: labels,
        colors: replaceColorWithReduxStatusColor(
          colors,
          categories.map((category) => category.status)
        ),
        values: data,
        totalLabel: 'Open Jobs',
        legendPlacement: 'left',
        legend: 'complete'
      }}
      type="donut"
    />
  );
};

export default OpenJobStatus;
